<i18n>
{
	"en": {
		"noFreeText": "There are no free texts yet."
	},
	"no": {
		"noFreeText": "Det er ingen fritekster ennå."
	}
}
</i18n>
<template>
	<t-no-content-panel
		:text="$t('noFreeText')"
		icon="search-text"
		iconType="bp"
	/>
</template>

<script>
export default { name: 'FreeText', };
</script>

